<div class="sBinnala {{ color }}">
  <mat-spinner></mat-spinner>
</div>
